// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f3d7d4b7","732":"90d20e9e","977":"5ac047b3"}[chunkId] + ".chunk.js";
};